import * as React from 'react';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import TextField from '@mui/material/TextField';

const NumericFormatCustom = React.forwardRef(
  (props, ref) =>  {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
        prefix="$"
      />
    );
  },
);

NumericFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function RHFNumericField({ value, name, ...other }) {

  return (
      <TextField
        value={value}
        name={name}
        fullWidth
        InputProps={{
          inputComponent: NumericFormatCustom,
        }}
        {...other}
      />
  );
}

RHFNumericField.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
